import { BackgroundImage, type BoxProps, Card, Title } from '@mantine/core'
import Link from 'next/link'

import { type CoreItemCategory } from '@flecto/types'
import { getImageUrl } from '@flecto/utils'

import { useAccessibilityProps } from '../../hooks/useAccessibilityProps'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import styles from './styles.module.css'

export type CardItemCategoryProps = BoxProps & {
  itemCategory?: CoreItemCategory
}

export function CardItemCategory({
  itemCategory,
  ...props
}: CardItemCategoryProps) {
  const path = useStorePathBuilder()
  const image = getImageUrl(itemCategory?.thumbnail_url) || ''
  const acessibilityProps = useAccessibilityProps({
    type: 'category',
    content: itemCategory?.name || '',
  })

  if (!itemCategory) {
    return
  }

  return (
    <Card
      component={Link}
      href={path(
        `/categories/${itemCategory.id}?category_ids=${itemCategory.id}`
      )}
      className={styles.cardCategory}
      {...props}
    >
      <Card.Section>
        <BackgroundImage
          src={image}
          h={200}
          opacity={0.3}
          {...acessibilityProps}
        />
        <Title
          order={4}
          ta='center'
          c='white'
          className={styles.withshadow}
          style={{
            zIndex: 100,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {itemCategory.name}
        </Title>
      </Card.Section>
    </Card>
  )
}
